import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
const tableData = [{
  method: 'Otros métodos',
  this: 'Este Megapack'
}, {
  method: 'Atacan solo la dieta',
  this: 'Trabaja intestino + nervios + energía juntos'
}, {
  method: 'Requieren equipamiento o gym',
  this: 'Todo desde tu casa con ingredientes del súper'
}, {
  method: 'Lenguaje médico complicado',
  this: 'Directo, claro, "de mujer a mujer"'
}, {
  method: 'Resultados en meses',
  this: 'Primeros cambios en 72 horas'
}, {
  method: 'Caros y difíciles de sostener',
  this: 'Accesible para el presupuesto argentino real'
}, {
  method: 'Te dejan sola con la información',
  this: 'Checklists diarios paso a paso'
}];
export function KitScale() {
  return <section className="py-20 bg-brand-card border-y border-brand-border" data-id="element-240">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-241">
        <FadeIn className="text-center mb-16" data-id="element-242">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-243">
            ⚖️ ¿POR QUÉ FUNCIONA?
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} className="overflow-x-auto" data-id="element-244">
          <table className="w-full text-left border-collapse min-w-[700px] bg-brand-cream rounded-2xl overflow-hidden border border-brand-border" data-id="element-245">
            <thead data-id="element-246">
              <tr className="border-b border-brand-border bg-brand-card" data-id="element-247">
                <th className="p-5 text-brand-dark font-bold w-1/2" data-id="element-248">
                  ❌ Otros métodos
                </th>
                <th className="p-5 text-brand-accent font-bold w-1/2" data-id="element-249">
                  ✅ Este Megapack
                </th>
              </tr>
            </thead>
            <tbody data-id="element-250">
              {tableData.slice(1).map((row, i) => <tr key={i} className="border-b border-brand-border hover:bg-brand-card/50 transition-colors" data-id="element-251">
                  <td className="p-5 text-brand-muted" data-id="element-252">{row.method}</td>
                  <td className="p-5 text-brand-dark font-medium" data-id="element-253">
                    {row.this}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </FadeIn>
      </div>
    </section>;
}